import React from "react";
import { IconButton, Tooltip, useTheme } from "@mui/material";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import { useThemeMode } from "../../theme/AppThemeProvider";

const ThemeToggle = ({ className }) => {
  const { mode, toggleMode } = useThemeMode();
  const theme = useTheme();
  const isDark = mode === "dark" || theme.palette.mode === "dark";
  return (
    <Tooltip title={isDark ? "Світла тема" : "Темна тема"}>
      <IconButton color="inherit" onClick={toggleMode} className={className} aria-label="toggle theme">
        {isDark ? <LightModeIcon/> : <DarkModeIcon/>}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;

